import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    // Keep in sync with CSS tokens in `src/styles/variables.css`
    primary: { main: '#5285ee', dark: '#3d6edc', light: '#6b97f5' },
    secondary: { main: '#ffcd73', dark: '#f0b840' },
    text: { primary: '#060606', secondary: '#555', disabled: '#888' },
    background: { default: '#c8d2e0', paper: '#fff' },
  },
  typography: {
    fontFamily: "'Montserrat', Arial, sans-serif",
  },
  breakpoints: {
    values: { xs: 0, sm: 430, md: 980, lg: 1280, xl: 1536 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          WebkitTapHighlightColor: 'transparent',
          '&:focus': {
            outline: 'none',
          },
          '&:focus-visible': {
            outline: '2px solid #ffcd73',
            outlineOffset: '2px',
          },
        },
      },
    },
  },
});

export const MD_UP = theme.breakpoints.up('md');
